import React from "react";
import { useState } from "react";
import { useSelector, useDispatch } from "types/store";

import { Modal, Popover, OverlayTrigger, Dropdown, MenuItem, ButtonToolbar, Button as BsButton } from "react-bootstrap";
import { toast } from "react-toastify";

import { isEnabled } from "utils/featureFlags";

import { Button, ButtonGroup, Icon } from "aible";
import { LineInput } from "components/Inputs/LineInput";
import Tooltip from "components/Inputs/Tooltip";
import AddCollaboratorButton from "components/Folders/AddCollaboratorButton";

import NextHeaderTabs from "components/Next/NextHeaderTabs";

import EditIcon from "images/edit-light.svg";
import ChartIcon from "images/Next-Icons/ChartIcon.svg";
import chatIcon from "images/chatbubble.svg";
import ListViewHeaderIcon from "images/Next-Icons/list-view-header.svg";
import HexViewHeaderIcon from "images/Next-Icons/hex-view-header.svg";
import NLQDashIcon from "images/presentation-screen-purple.svg";
import KPIDashIcon from "images/chart-line-purple.svg";
import SettingsIcon from "images/settings.svg";
import LightSlidersIcon from "images/Light Sliders icon purple.svg";

import * as nextReducer from "containers/Next/NextReducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as languageModelArtifactReducer from "containers/LanguageModelArtifact/reducer";
import * as viewReducer from "containers/View/reducer";
import * as chatAppReducer from "containers/ChatApp/reducer";

import styles from "./style.module.css";
import * as homeReducer from "containers/Home/reducer";
import * as globalReducer from "containers/App/reducer";
import { chatGPT } from "components/ChatGPT/style.module.css";

import FineTuningButton from "components/LanguageModelArtifact/FineTuningButton/FineTuningButton";
import ModelTrainingButton from "components/LanguageModelArtifact/TrainingData/ModelTrainingButton";
import TestChatAppSelector from "components/ChatApp/TestChatAppSelector";

const ChatGPTHeader = ({ id, previousReportData } = {}) => {
  const dispatch = useDispatch();

  const [shouldSaveProject, setShouldSaveProject] = useState(null);

  const reportLabel = useSelector((state) => nextReducer.getReportLabel(state, id));
  const activeTab = useSelector((state) => nextReducer.getActiveTab(state, id));
  const comparisonOptions = useSelector((state) => nextReducer.getComparisonOptions(state, id));
  const chatGPTShowSettings = useSelector((state) => chatGPTReducer.getShowSettings(state));
  const isSavingReport = useSelector((state) => nextReducer.getIsSavingReport(state, id));

  const conversationArray = useSelector((state) => chatGPTReducer.getConversationArray(state, undefined, true));

  const datasetId = useSelector((state) => nextReducer.getDatasetId(state, id));
  const dataset = useSelector((state) => homeReducer.getDataset(state, datasetId));
  const hasDataset = dataset !== undefined && datasetId > 0;

  const hasOutcome = hasDataset && dataset?.outcome;

  const hexMap = useSelector((state) => nextReducer.getHexMap(state, id));
  const hasHexes = hexMap && Object.keys(hexMap)?.length > 0;

  const isKPIAnalysis = useSelector((state) => homeReducer.getIsKPIAnalysis(state, datasetId));

  const chatApp = useSelector((state) => chatGPTReducer.getChatApp(state));

  const uiState = useSelector((state) => globalReducer.getUiState(state));
  const isShareLink = uiState?.type === "SHARE_LINK";

  const updateReportLabel = (reportLabel) =>
    dispatch(nextReducer.updateReportLabelAndContentGenerationCollection(id, reportLabel));
  const updateActiveTab = (activeTab) => dispatch(nextReducer.updateActiveTab(id, activeTab));
  const chatGPTUpdateShowSettings = (showSettings) => dispatch(chatGPTReducer.updateShowSettings(showSettings));
  const saveNext = (saveMessage) => dispatch(nextReducer.saveNext(id, saveMessage));

  const handleKPIAnalysis = () => dispatch(chatGPTReducer.handleKPIAnalysis());

  const linkColorDarkMode = useSelector((state) => chatGPTReducer.getLinkColorDarkMode(state));
  const linkColorDarkColor = "#4B495B";

  const isSmallScreen = useSelector((state) => viewReducer.getIsSmallScreen(state));

  const updateIsShowChatExportModal = (isShowChatExportModal) =>
    dispatch(chatGPTReducer.updateIsShowChatExportModal(isShowChatExportModal));

  const IS_SIMPLE_MODE = true;

  const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
  const isOpenShellChat = chatType === "OPENSHELL";

  return (
    <div className={styles.nextHeader}>
      <div className={styles.chatGPTTitle} style={isOpenShellChat ? { width: "290px" } : undefined}>
        {"reportLabel" && (
          <Tooltip
            trigger={isShareLink ? [] : ["hover"]}
            overlay={isEnabled("chat-aible-consumer") ? "Click To Rename Chat" : "Click To Rename Project"}
          >
            <div className={styles.titleHover}>
              {/* {!isShareLink && (
                <img className={styles.titleEdit} src={EditIcon} alt={"Edit"} />
              )} */}
              <LineInput
                isMediumBox
                isCleanEditable
                style={{ width: "100%" }}
                value={reportLabel}
                onChange={(val) => {
                  if (val !== reportLabel) {
                    setShouldSaveProject(true);

                    if (val.length) {
                      updateReportLabel(val);
                    } else {
                      updateReportLabel("My Untitled Project");
                    }
                  }
                }}
                isLocked={isShareLink}
                placeholder={reportLabel ? reportLabel : "My Untitled Project"}
              />
            </div>
          </Tooltip>
        )}
      </div>
      {!isSmallScreen && <TestChatAppSelector />}
      {!isShareLink &&
      (isEnabled("aible-optimize") || isEnabled("chat-aible")) &&
      (hasDataset || IS_SIMPLE_MODE) &&
      !isSmallScreen ? (
        <NextHeaderTabs id={id} previousReportData={previousReportData} />
      ) : (
        <div className={styles.centerHeader} />
      )}
      {/* {IS_SIMPLE_MODE && (
        <div className={styles.simpleSwitch}>
          <ButtonGroup>
            <Button
              active={activeTab === "CHATGPT"}
              onClick={() => {
                updateActiveTab("CHATGPT");
              }}
            >
              {"Chat"}
            </Button>
            <Button
              active={activeTab === "NLQ Dashboard"}
              onClick={() => {
                updateActiveTab("NLQ Dashboard");
              }}
            >
              {"Present"}
            </Button>
          </ButtonGroup>
        </div>
      )} */}
      {isEnabled("add-collaborators-button") && !isShareLink && !isSmallScreen && activeTab !== "NLQ Dashboard" && (
        <div className={styles.addCollaboratorButton}>
          <AddCollaboratorButton id={id} />
        </div>
      )}
      {isEnabled("model-fine-tuning") && !isShareLink && !isSmallScreen && activeTab !== "NLQ Dashboard" && (
        <ModelTrainingButton />
      )}
      {!isEnabled("spark-agents-templates-view") &&
        isEnabled("model-fine-tuning") &&
        !isShareLink &&
        !isSmallScreen &&
        activeTab !== "NLQ Dashboard" && <FineTuningButton />}
      {IS_SIMPLE_MODE ? (
        <div />
      ) : (
        (isEnabled("aible-explore") || isEnabled("aible-optimize") || isEnabled("chat-aible-advanced-controls")) &&
        (activeTab === "EXPLORE" ||
          activeTab === "DASHBOARD" ||
          activeTab === "CHATGPT" ||
          activeTab === "NLQ Dashboard" ||
          activeTab === "KPI DASHBOARD") &&
        (hasDataset || true) && (
          <ButtonGroup>
            {!isShareLink && isEnabled("aible-dashboard") && !isSmallScreen && (
              <Tooltip
                overlay={
                  hasHexes
                    ? hasOutcome
                      ? "Show Dashboard"
                      : "Select an outcome on the dataset to generate dashboard"
                    : "Dashboard is unavailable"
                }
                placement={"bottom"}
                trigger={["hover"]}
              >
                <Button
                  active={activeTab === "DASHBOARD"}
                  onClick={() => updateActiveTab("DASHBOARD")}
                  disabled={!hasOutcome || !hasHexes}
                >
                  <div className={styles.bFlex}>
                    <Icon size={16} src={ChartIcon} />
                  </div>
                </Button>
              </Tooltip>
            )}
            {!isShareLink && !isSmallScreen && (
              <Tooltip
                overlay={
                  hasHexes
                    ? hasOutcome
                      ? "Show Hexes"
                      : "Select an outcome on the dataset to generate hexes"
                    : "Hex view is unavailable"
                }
                placement={"bottom"}
                trigger={["hover"]}
              >
                <Button
                  active={activeTab === "EXPLORE"}
                  onClick={() => {
                    if (activeTab !== "EXPLORE") {
                      updateActiveTab("EXPLORE");
                    }
                  }}
                  disabled={!hasOutcome || !hasHexes}
                >
                  <div className={styles.bFlex}>
                    <Icon size={16} src={HexViewHeaderIcon} />
                  </div>
                </Button>
              </Tooltip>
            )}
            {((isEnabled("chat-aible-consumer") && isEnabled("chat-aible-advanced-controls")) ||
              (isEnabled("chat-aible") && (isEnabled("aible-optimize") || isEnabled("aible-explore")))) && (
              <Tooltip overlay={"Show ChatAible"} placement={"bottom"} trigger={["hover"]}>
                <Button
                  active={activeTab === "CHATGPT"}
                  onClick={() => {
                    updateActiveTab("CHATGPT");
                  }}
                >
                  <div className={styles.bFlex}>
                    <Icon size={16} src={chatIcon} />
                  </div>
                </Button>
              </Tooltip>
            )}
            {isEnabled("nlq-dashboard") && (
              <Tooltip overlay={"Show Chat Dashboard"} placement={"bottom"} trigger={["hover"]}>
                <Button
                  active={activeTab === "NLQ Dashboard"}
                  onClick={() => {
                    updateActiveTab("NLQ Dashboard");
                  }}
                >
                  <div className={styles.bFlex}>
                    <Icon size={16} src={NLQDashIcon} />
                  </div>
                </Button>
              </Tooltip>
            )}
            {isEnabled(`document-set-kpi-analysis`) && isKPIAnalysis && !isSmallScreen && (
              <Tooltip overlay={"Show What's Changed Overview"} placement={"bottom"} trigger={["hover"]}>
                <Button
                  active={activeTab === "KPI DASHBOARD"}
                  onClick={() => {
                    updateActiveTab("KPI DASHBOARD");
                    handleKPIAnalysis();
                  }}
                  disabled={!isKPIAnalysis}
                >
                  <div className={styles.bFlex}>
                    <Icon size={16} src={KPIDashIcon} />
                  </div>
                </Button>
              </Tooltip>
            )}
            {/* {!isShareLink && isEnabled("nlq-dashboard") && (
              <Tooltip
                overlay={
                  "Click this to copy the Dashboard's URL to your clipboard"
                }
                placement={"bottom"}
                trigger={["hover"]}
              >
                <Button
                  onClick={() => {
                    const url =
                      window.location.href +
                      (window.location.href.indexOf("/__dash") === -1
                        ? "/__dash"
                        : "");

                    toast("Dashboard URL copied to clipboard.", {
                      type: toast.TYPE.SUCCESS,
                      position: toast.POSITION.TOP_CENTER,
                      autoClose: 3500,
                    });

                    navigator.clipboard
                      .writeText(url)
                      .then((c) => console.log("clipboard stuff"));
                    //window.open(url);
                  }}
                >
                  {"Link"}
                </Button>
              </Tooltip>
            )} */}
          </ButtonGroup>
        )
      )}
      {!isShareLink &&
        chatType !== "OPENSHELL" &&
        (isEnabled("chat-aible-advanced-controls") || chatGPTShowSettings || conversationArray?.length > 0) &&
        activeTab !== "NLQ Dashboard" &&
        activeTab !== "KPI DASHBOARD" && (
          <Button
            onClick={() => {
              chatGPTUpdateShowSettings(!chatGPTShowSettings);
            }}
            active={chatGPTShowSettings}
            type={"secondary"}
            style={{
              marginLeft: "10px",
              fontSize: "13px",
              color: linkColorDarkMode
                ? linkColorDarkColor
                : chatApp?.wizard?.linkColor !== undefined
                  ? "#FFFFFF"
                  : undefined,
              ...(chatApp?.wizard?.linkColor !== undefined
                ? {
                    background: chatApp?.wizard?.linkColor,
                    borderColor: chatApp?.wizard?.linkColor
                  }
                : {})
            }}
            className={chatApp?.wizard?.linkColor !== undefined ? styles.forceButtonHover : ""}
            greyscaleDefaultState={true}
          >
            <img src={LightSlidersIcon} className={styles.settingsIcon} />
            {"Options"}
          </Button>
        )}
      {!isShareLink ? (
        isEnabled("nlq-dashboard") ? (
          <Dropdown id="saveLink" pullRight style={{ marginLeft: "10px", display: "flex", flexWrap: "nowrap" }}>
            <Button
              onClick={() => {
                setShouldSaveProject(undefined);
                saveNext("Chat Saved");
              }}
              type={shouldSaveProject ? "primary" : "secondary"}
              isLoading={isSavingReport}
              greyscaleDefaultState
              style={{
                fontSize: "13px",
                float: "left",
                borderRadius: "3px 0px 0px 3px",
                color: linkColorDarkMode
                  ? linkColorDarkColor
                  : chatApp?.wizard?.linkColor !== undefined
                    ? shouldSaveProject
                      ? "#FFFFFF"
                      : "#FFFFFF"
                    : undefined,
                ...(chatApp?.wizard?.linkColor !== undefined
                  ? {
                      background: chatApp?.wizard?.linkColor,
                      borderColor: chatApp?.wizard?.linkColor
                    }
                  : {})
              }}
              className={chatApp?.wizard?.linkColor !== undefined ? styles.forceButtonHover : ""}
            >
              {"Save"}
            </Button>
            {isEnabled("chat-save-dropdown-options") && (
              <Dropdown.Toggle
                style={{
                  padding: "8px 6px 8px",
                  borderTopRightRadius: "3px",
                  borderBottomRightRadius: "3px",
                  borderLeft: "none",
                  color: "#7E7D9A"
                }}
              />
            )}
            <Dropdown.Menu>
              <MenuItem
                eventKey="1"
                onClick={() => {
                  const url = window.location.href + (window.location.href.indexOf("/__dash") === -1 ? "/__dash" : "");

                  toast("Dashboard URL copied to clipboard.", {
                    type: toast.TYPE.SUCCESS,
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3500
                  });

                  navigator.clipboard.writeText(url).then((c) => console.log("clipboard stuff"));
                  //window.open(url);
                }}
              >
                <div style={{ color: "#7E69D7" }}>{"Share Link To Chat Dashboard"}</div>
              </MenuItem>
              {isEnabled("allow-chat-export") && (
                <MenuItem eventKey="2" onClick={() => updateIsShowChatExportModal(true)}>
                  <div style={{ color: "#7E69D7" }}>{"Export Chat to Docs/PDF"}</div>
                </MenuItem>
              )}
            </Dropdown.Menu>
          </Dropdown>
        ) : (
          <ButtonToolbar style={{ marginLeft: "10px", flexShrink: "0" }} id="saveButton">
            <Button
              onClick={() => {
                setShouldSaveProject(undefined);
                saveNext("Chat Saved");
              }}
              type={shouldSaveProject ? "primary" : "secondary"}
              isLoading={isSavingReport}
              style={{
                color: linkColorDarkMode
                  ? linkColorDarkColor
                  : chatApp?.wizard?.linkColor !== undefined
                    ? shouldSaveProject
                      ? "#FFFFFF"
                      : undefined
                    : undefined,
                ...(chatApp?.wizard?.linkColor !== undefined
                  ? {
                      background: chatApp?.wizard?.linkColor,
                      borderColor: chatApp?.wizard?.linkColor
                    }
                  : {})
              }}
              className={chatApp?.wizard?.linkColor !== undefined ? styles.forceButtonHover : ""}
              greyscaleDefaultState
            >
              {"Save"}
            </Button>
          </ButtonToolbar>
        )
      ) : (
        <React.Fragment />
      )}
    </div>
  );
};

export default ChatGPTHeader;
